// extracted by mini-css-extract-plugin
module.exports = {"main":"ShopItems_main__HR_LI"};